<nz-form-control *ngIf="recordProperty !== undefined">
  <nz-input-group [nzAddOnAfter]="isLink ? View : null">
    <input #input
    [class]="parentClass"
    [nz-tooltip]="recordProperty.ValueAsObject"
    [type]=" field.AdditionalInformationParsed.IsPassword? 'password' : 'text'"
      [name]="sectionTagName+'.' +field.FieldName" nz-input [ngModelOptions]="{ updateOn: 'blur' }"
      [(ngModel)]="recordProperty.ValueAsObject" (ngModelChange)="valueChanged()" [disabled]="recordProperty.ReadOnly"
      (keydown)="keyValueChanged($event)"
      (focusout)="fieldFocusOut();" [maxlength]="field.MaxLength" />
  </nz-input-group>
  <ng-template #View>
    <nz-button-group>
      <button nz-button nzType="default" nzSearch (click)="OpenURL(recordProperty.ValueAsObject)">
        <i class="fal fa-eye"></i>
      </button>
    </nz-button-group>
  </ng-template>
</nz-form-control>
